import { put } from 'redux-saga/effects';

import { CreateImageElementAction, createElement } from 'js/actionCreators/scribeActions';
import ScribeImageElementModel from 'js/models/ScribeImageElementModel';
import { ScribeImageElementModelProps } from 'js/types';

import processImageOnChange from '../sagaHelpers/processImageOnChange';

export function* createImageElement(action: CreateImageElementAction) {
  const { scribeId, initialData = {} as ScribeImageElementModelProps, drawTypeOverride } = action;
  const newElement = new ScribeImageElementModel(initialData);

  yield processImageOnChange(newElement);

  yield put(createElement(newElement, scribeId, drawTypeOverride));
}
